import React from "react";
import { editorLink,MentionConvert } from "Source/globalComponents";
import draftToHtml from 'draftjs-to-html';
import { connect } from "react-redux";
import { Icons } from "Assets/icons";
import Tooltip from "@/src/components/common/Elements/Tooltip/Tooltip";
import Axios from "Source/axiosPool";

@connect(store => {
    return {
        settings: store.settings,
        project: store.project,
        loggedUser: store.loggedUser

    }
})
class Reply extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { dispatch, message, reply, onReply, settings, project, isAdmin = false, loggedUser, isEditing} = this.props
        const isJsonString = (str) => {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }

            return true;
        }
        const handleClose = () => {
            if (this.props.onClose) {
                this.props.onClose()
            }

        }
        const autoScroll = (msg) => {
            if (this.props.onSelect) {
                this.props.onSelect(msg)
            }

        }

        const downloadDocument = (data) => {
            if (data.type === "document") {
                window.open(encodeURI(`/api/downloadDocument?fileName=${data.name}&origin=${data.origin}`));
            }
        }
        const deleteDocument = (data) => {

            dispatch({ type: "SET_CONVERSATIONS_FILE_SELECTED", selected: data });
            $(`#deleteOnConversationModal`).modal("show");
        }

        const handleFileOpen = (doc) => {
            // window.open(window.location.origin + `/account#/projects/${project.Selected.id}/files?action=copy&file-id=${doc.id}`, '_blank');
            Axios.get(`/api/document/detail/${doc.id}`, {}).then(ret => {
                if (ret) {
                    setTimeout(() => {
                        const documentObj = ret.data;
                        dispatch({ type: "SET_DOCUMENT_SELECTED", Selected: { ...documentObj, action: "VIEW" } });
                        $(`#documentViewerModal`).modal("show");
                    }, 500)
                }
            })


        }
        const convUser = message.users ? `${message.users.firstName} ${message.users.lastName}` : ''
        let convMsg = ""
        let isParentOld= false

        if(message && message.comment && isJsonString(message.comment)) {
            convMsg =   draftToHtml(JSON.parse(message.comment))
         } else {
            convMsg = MentionConvert({string:message.comment})
            isParentOld = true
         }
        let messageContent = ""
        let isReplyOld = false
        if(reply) {
             if( isJsonString(reply.comment)) {
                messageContent =  draftToHtml(JSON.parse(reply.comment)) 
             } else {
                messageContent = MentionConvert({string:reply.comment})
                isReplyOld = true
             }
        }
        const convDocument = message.conversationDocuments || []
        const parentDocument = reply?reply.conversationDocuments : []
        const existingDocuments = convDocument.filter(doc=>!doc.isDeleted);
        const displayDocuments = onReply 
            ? existingDocuments.length > 0 ? existingDocuments.slice(0, 2) : []
            : convDocument.length > 0 ? convDocument.slice(0, 2) : [];;
        const projectId = project.Selected ? project.Selected.id : null

        if (reply && !reply.forEdit && reply.isEdit > 0) {
            const editedHtml = `<span class="editedTag"> (Edited) </span>`;
            messageContent = messageContent.replace(/<\/p>(?![\s\S]*<\/p>[\s\S]*$)/i, editedHtml+'</p>')
        }
        
        return (
            <div class="reply-container">
                <div class="reply-to-details" onClick={() => { autoScroll(message) }} >
                    <p class="brndnTxt-m">{`Replying to ${convUser}`}</p>
                    {message.isDeleted ?
                        <div class="message-content pd0" >
                            <div class='deleted pd0'>
                                {`Message has been deleted`}
                            </div>
                        </div> :
                        <div class="reply-message" >
                            <div class="inner-message" style={{display: 'flex', alignItems: 'center'}}>
                                {!isParentOld? <div dangerouslySetInnerHTML={{ __html: editorLink(convMsg) }} />:convMsg}
                            </div>
                            <div class="message-attachment">
                                { displayDocuments.map((cdoc, index) => {
                                    const doc = cdoc.document
                                    const ext = doc.origin.split('.').pop()
                                    let isDocument = ext
                                    if (ext === "jpeg" || ext === "png" || ext === "jpg") {
                                        isDocument = "image";
                                    }
                                    return (

                                        <div class={`msgDocs ${cdoc.isDeleted ? 'deleted' : ''} `}>
                                            {cdoc.isDeleted ?
                                                <div class="msgDetails-wrapper">
                                                    <div class="msg-details" >
                                                        <i class="material-icons mr5 text-size20">description</i>
                                                        <a>{`File has been deleted`}</a>
                                                    </div>
                                                </div>
                                                :
                                                <div class="msgDetails-wrapper">
                                                    <div class="msg-details" >
                                                        <i class="material-icons mr5 text-size20">description</i>
                                                        <span>
                                                            {doc.origin.length > 25 ? doc.origin.substr(0, 25) + "..." : doc.origin}
                                                        </span> 
                                                        {/* {onReply ? <span>
                                                            {doc.origin.length > 25 ? doc.origin.substr(0, 25) + "..." : doc.origin}
                                                        </span> :
                                                            <a href={`${window.location.origin}/account#/projects/${projectId}/files?action=copy&file-id=${doc.id}`} target="_blank" key={doc.id} onClick={(e) => { e.preventDefault(); handleFileOpen(doc) }}>
                                                                {doc.origin.length > 25 ? doc.origin.substr(0, 25) + "..." : doc.origin}
                                                            </a>
                                                        } */}

                                                    </div>
                                                    {/* {!onReply && <div class="msg-actions">
                                                        <a class="btnDownload"   data-tooltip-id={`file-download-${doc.id}`} onClick={() => downloadDocument(doc)}>
                                                            <i class="material-icons">{Icons.DownloadIcon}</i>
                                                        </a>
                                                        <Tooltip id={`file-download-${doc.id}`} place="bottom" effect="solid">Download</Tooltip>
                                                        {(isAdmin || isUploader) && <a class="btnDelete"   data-tooltip-id={`file-delete-${doc.id}`} onClick={() => deleteDocument(doc)}>
                                                            <i class="material-icons">delete_outline</i>
                                                        </a>}

                                                        <Tooltip id={`file-delete-${doc.id}`} place="bottom" effect="solid">Delete</Tooltip>
                                                    </div>
                                                    } */}

                                                </div>
                                                    
                                            }
                                            {/* {(isDocument === 'image' && !cdoc.isDeleted) &&
                                                <div class="imgWrapper">
                                                    <img class="img-responsive" src={`${url}`} />
                                                </div>
                                            } */}
                                        </div>
                                    );
                                })}

                                {existingDocuments.length > 2 &&
                                    <span class="fileCounter">
                                        +{existingDocuments.length - 2}
                                        <span class="ml5">attachments</span>
                                    </span>}
                            </div>
                        </div>
                    }
                </div>
                {reply &&
                    <React.Fragment>
                        <div class="reply-message"  >
                            {!isEditing && !isReplyOld && <div dangerouslySetInnerHTML={{ __html: editorLink(messageContent) }} /> }
                            {!isEditing && isReplyOld  &&  <div> {messageContent}</div> }
                        </div>
                        <div class="message-attachment">
                                {parentDocument.length > 0 && parentDocument.map((cdoc, index) => {
                                    const doc = cdoc.document
                                    const ext = doc.origin.split('.').pop()
                                    let isDocument = ext

                                    if (ext === "jpeg" || ext === "png" || ext === "jpg") {
                                        isDocument = "image";
                                    }

                                    const url = `/api/file/upload/${doc.name}`;
                                    const isUploader = doc.uploadedBy === loggedUser.data.id
                                    return (

                                        <div class={`msgDocs ${cdoc.isDeleted ? 'deleted' : ''} `}>
                                            {cdoc.isDeleted ?
                                                <div class="msgDetails-wrapper">
                                                    <div class="msg-details" >
                                                        <i class="material-icons mr5 text-size20">description</i>
                                                        <a>{`File has been deleted`}</a>
                                                    </div>
                                                </div>  
                                                :
                                                <div class="msgDetails-wrapper">
                                                    <div class="msg-details" >
                                                        <i class="material-icons mr5 text-size20">description</i>
                                                        <a href={`${window.location.origin}/account#/projects/${projectId}/files?action=copy&file-id=${doc.id}`} target="_blank" key={index} onClick={(e) => { e.preventDefault(); handleFileOpen(doc) }}>
                                                            {doc.origin.length > 25 ? doc.origin.substr(0, 25) + "..." : doc.origin}
                                                        </a>
                                                    </div>
                                                    <div class="msg-actions">
                                                        <a class="btnDownload"   data-tooltip-id={`file-download-${doc.id}`} onClick={() => downloadDocument(doc)}>
                                                            <i class="material-icons">{Icons.DownloadIcon}</i>
                                                        </a>
                                                        <Tooltip id={`file-download-${doc.id}`} place="bottom" effect="solid">Download</Tooltip>
                                                        {(isAdmin ||isUploader)  && <a class="btnDelete"   data-tooltip-id={`file-delete-${doc.id}`} onClick={() => deleteDocument(doc)}>
                                                            <i class="material-icons">delete_outline</i>
                                                        </a>}
                                                        
                                                        <Tooltip id={`file-delete-${doc.id}`} place="bottom" effect="solid">Delete</Tooltip>
                                                    </div>
                                                </div>
                                            }
                                            {(isDocument === 'image' && !cdoc.isDeleted) &&
                                                <div class="imgWrapper">
                                                    <img class="img-responsive" src={`${url}`} />
                                                </div>
                                            }
                                        </div>
                                    );
                                })
                                }
                            </div>
                    </React.Fragment>
                }
                {onReply &&
                    <div class="actions">
                        <a onClick={handleClose}>
                            <i class="material-icons-outlined"> cancel </i>
                        </a>
                    </div>}

            </div>
        );
    }
}

export default Reply;